import styled from 'styled-components';

type StyledImageProps = {
    $heightValue: number;
};

export const StyledWidgetImageWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: inherit;
    width: inherit;
`;

export const StyledWidgetImage = styled.img<StyledImageProps>`
    max-height: ${({ $heightValue: heightValue }) => (heightValue !== 0 ? `${heightValue}px` : '100%')};
    max-width: 100%;
    display: flex;
    align-items: center;
    border-radius: 16px;
    padding: 8px 14px 12px 9px;
`;
